import React from 'react';
import { Card } from '../ui/card';
import { Badge } from '../ui/badge';
import { ArrowRight } from 'lucide-react';

const palette = {
  violet: 'bg-violet-50 border-violet-200 text-violet-700',
  sky: 'bg-sky-50 border-sky-200 text-sky-700',
  emerald: 'bg-emerald-50 border-emerald-200 text-emerald-700',
  amber: 'bg-amber-50 border-amber-200 text-amber-700',
};

const estadoBadge = {
  pronto: 'bg-violet-100 border-violet-300 text-violet-700',
  backlog: 'bg-ink-100 border-ink-300 text-ink-600',
  activo: 'bg-emerald-100 border-emerald-300 text-emerald-700',
};

export const CentroInteligenciaCard = ({ titulo, descripcion, icon, color, estado, navegar, testid, valor, leyenda }) => {
  return (
    <Card
      onClick={navegar}
      className={`p-4 border ${palette[color]} relative ${navegar ? 'cursor-pointer card-hover' : 'opacity-90'}`}
      data-testid={testid}
    >
      <div className="flex items-start justify-between mb-3">
        <div className="w-9 h-9 rounded-lg bg-white/70 flex items-center justify-center">{icon}</div>
        <Badge className={`border text-xs ${estadoBadge[estado]}`}>
          {estado === 'pronto' ? 'Pronto' : estado === 'backlog' ? 'Backlog' : 'Activo'}
        </Badge>
      </div>
      <h3 className="text-sm font-semibold text-ink-900">{titulo}</h3>
      <p className="text-xs text-ink-600 mt-1 leading-snug">{descripcion}</p>
      <div className="mt-3 text-2xl font-heading font-bold text-ink-900">{valor ?? 0}</div>
      <p className="text-xs text-ink-500">{leyenda || 'resultados hoy'}</p>
    </Card>
  );
};

export const QuickStat = ({ title, value, detail, icon, tone = 'neutral', onClick, cta, testid }) => {
  const isAction = !!onClick;
  return (
    <Card
      onClick={onClick}
      data-testid={testid}
      className={`p-5 border-ink-200 bg-white card-hover ${isAction ? 'cursor-pointer' : ''}`}
    >
      <div className="flex items-start justify-between">
        <div>
          <p className="text-xs uppercase tracking-wider text-ink-500 font-medium">{title}</p>
          <p className="text-2xl font-heading font-bold text-ink-900 mt-1">{value}</p>
          <p className="text-xs text-ink-500 mt-1">{detail}</p>
        </div>
        <div className={`h-10 w-10 rounded-lg flex items-center justify-center ${tone === 'ok' ? 'bg-emerald-50 text-emerald-600' : 'bg-brand-50 text-brand-600'}`}>
          {icon}
        </div>
      </div>
      {cta && (
        <div className="mt-3 text-xs text-brand-700 font-medium inline-flex items-center gap-1">
          {cta} <ArrowRight className="w-3 h-3" />
        </div>
      )}
    </Card>
  );
};
